import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { usePermissionSlot } from '@/hooks/useMenuPermission'
import BoardPage from './list/page.generated'
import { BOARD_BASE_PATH, BOARD_MENU_CODE } from './consts'

/** 타이틀 행의 [등록] — 생성본에서 타이틀 행 버튼은 이것 하나다. */
export const REGISTER_BUTTON_SELECTOR = '.dev-page-header-wrap button'

/**
 * 게시판 목록(RP14) — UI 는 컨덕터 생성본(list/page.generated.tsx), 데이터는 list/wiring.ts.
 * ponytail: 컨덕터(d35b1606)가 타이틀 행 버튼에 배선 슬롯·권한 가드를 내지 않아(mustWire unwired) [등록] 만 DOM 으로 잇는다.
 *  생성기가 버튼 슬롯을 내면 wiring.actions 로 옮기고 이 effect 를 지운다.
 */
export default function BoardListPage() {
  const rootRef = useRef<HTMLDivElement>(null)
  const navigate = useNavigate()
  const canRegister = usePermissionSlot(BOARD_MENU_CODE).canShow('REGISTER')

  useEffect(() => {
    const button = rootRef.current?.querySelector<HTMLButtonElement>(REGISTER_BUTTON_SELECTOR)
    if (!button) return undefined
    // [hidden] 은 antd .ant-btn { display: inline-flex } 에 진다 — display 를 직접 끈다.
    button.style.display = canRegister ? '' : 'none'
    const goRegister = () => navigate(`${BOARD_BASE_PATH}/new`)
    button.addEventListener('click', goRegister)
    return () => button.removeEventListener('click', goRegister)
  }, [canRegister, navigate])

  return (
    <div ref={rootRef}>
      <BoardPage />
    </div>
  )
}
